import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import logo from "../assets/logo-symbol.png";
import "../styles/Navbar.css";

const Navbar = () => {

  const location = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about-us" },
    // { label: "Services", to: "/services" },
    { label: "Who We Help", to: "/services" },
    { label: "Referrals", to: "/referrals" },
    // { label: "Resources", to: "/resources" },
    { label: "Contact", to: "/contact-us" },
  ];

  return (
    <header className="navbar">

      <div className="navbar-top">

        <span>Supporting Australians through Occupational Therapy</span>

        <div className="social-links">

          <a href="https://facebook.com/primeequilibrium">
            <FaFacebookF />
          </a>

          <a href="#">
            <FaLinkedinIn />
          </a>

        </div>

      </div>

      <div className="navbar-main container">

        <Link to="/" className="brand">

          <img src={logo} alt="Prime Equilibrium" />

          <div className="brand-details">

            <h2>

              <span className="brand-prime">
                PRIME
              </span>

              <span className="brand-equilibrium">
                EQUILIBRIUM
              </span>

            </h2>

            <p className="brand-subtitle">
              Occupational Therapy
            </p>

          </div>

        </Link>

        <nav className={open ? "nav open" : "nav"}>

          {links.map((item) => (

            <Link
              key={item.to}
              to={item.to}
              className={
                location.pathname === item.to
                  ? "active"
                  : ""
              }
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>

          ))}
{/* 
          <Link
            to="/contact-us"
            className="btn btn-primary mobile-book"
          >
            Book Now
          </Link> */}

        </nav>

        {/* <Link
          to="/book-now"
          className="btn btn-primary desktop-book"
        >
          Book Now
        </Link> */}

        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? <FaTimes /> : <FaBars />}
        </button>

      </div>

    </header>
  );
};

export default Navbar;